/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="selfCheckInKiosk.module.ts" />
///<reference path="selfCheckInKiosk.logic.ts"/>


module Meevo.Plugins.SelfCheckInKiosk {

    class SelfCheckInKioskController {
        static $inject = [
            '$rootScope',
            '$state',
            'meevo.AppSettings',
            'meevo.components.modal.ModalService',
            'meevo.plugins.selfCheckInKiosk.SelfCheckInKioskLogic',
            'meevo.components.common.IdentityService',
        ];

        get showHomeIcon() {
            return this.$state.current.name !== `${this.appSettings.ROUTE_NAMES.selfCheckInKiosk}.login`;
        }
        constructor(
            protected $rootScope: ng.IRootScopeService,
            protected $state: ng.ui.IStateService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected selfCheckInKioskLogic: SelfCheckInKioskLogic,
            protected identityService: Meevo.Components.Common.IIdentityService,
        ) {
            this.selfCheckInKioskLogic.loadSettings();

        }

        /**
         * Close current tab
         * */
        closeContext(): void {
            this.$state.go(`${this.appSettings.ROUTE_NAMES.selfCheckInKiosk}.login`);
            this.selfCheckInKioskLogic.reset();

            setTimeout(() => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.get(this.appSettings.ROUTE_NAMES.selfCheckInKiosk), null);
            });
        }

        home() {
            this.modalService.obConfirm('LABEL_KIOSK_START_OVER')
                .then(() => {
                    this.$state.go(`${this.appSettings.ROUTE_NAMES.selfCheckInKiosk}.login`);
                    this.selfCheckInKioskLogic.reset();
                })
                .catch(() => {
                });
        }
    }


    angular.module('meevo.plugins.selfCheckInKiosk')
        .controller('meevo.plugins.selfCheckInKiosk.SelfCheckInKioskController', SelfCheckInKioskController);
}
